import { authClient } from './amplifyClient';

/**
 * Ask production to send the PM due-soon email for this meter reading.
 * Runs after the reading is saved so the notice is not left for the hourly check.
 */
export async function notifyPMDueSoon(unitId: string, currentUM: number): Promise<void> {
    if (!unitId || !(currentUM > 0)) return;
    const result = await authClient.mutations.notifyPMDueSoon({
        unitId,
        currentUM,
    });
    const errors = result.errors?.map((error) => error.message).filter(Boolean) ?? [];
    if (errors.length > 0) {
        throw new Error(errors.join('; '));
    }
}
